export default __webpack_public_path__ + "static/media/illustrativeMoneyBill.495a3af6.svg";